<template>
  <div class="brand-icons">
    <h3 class="brand-icons__title">{{ $t('brand-icons.title') }}</h3>
    <ul class="brand-icons__row">
      <li v-for="(v, k) in items" :key="k" class="brand-icons__item">
        <div class="brand-icons__img">
          <img
            v-lazyload
            :data-src="`
              https://static-goengines.gocase.com.br/qr-img/${v}
            `"
            :alt="$t(`brand-icons.${k}`)"
            class="lazy"
          />
        </div>
        <p>{{ $t(`brand-icons.${k}`) }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    delivery: {
      type: Boolean,
      default: true,
    },
    warranty: {
      type: Boolean,
      default: true,
    },
    quality: {
      type: Boolean,
      default: true,
    },
    personalization: {
      type: Boolean,
      default: true,
    },
    returns: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    items() {
      const delivery = '46855570650602751633529066383.png'
      const warranty = '25688713566412161633529181469.png'
      const quality = '44943699836663111633529221123.png'
      const personalization = '99220501761391461633529203738.png'
      const returns = '63295667989645411633529034479.png'

      return this.$isBrStore
        ? {
            delivery,
            warranty,
            quality,
            personalization,
            returns,
          }
        : {
            delivery,
            warranty,
            quality,
            personalization,
          }
    },
  },
}
</script>

<style lang="scss">
#minibanners-shelves + .brand-icons {
  padding-top: 30px;
}

.brand-icons {
  padding: 20px 15px;
  background-color: #f5fbfb;

  .brand-icons__title {
    font-size: 20px;
    margin-bottom: 30px;
    margin-top: 15px;
  }

  .brand-icons__row {
    text-align: left;

    .brand-icons__item {
      display: flex;
      margin-bottom: 20px;

      .brand-icons__img {
        width: 80px;
        min-width: 80px;
        margin-right: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      img {
        display: block;
        width: auto;
        height: 50px;
        margin: 0 auto;
      }
    }
  }
}

@media (min-width: $v4_desktop) {
  #minibanners-shelves + .brand-icons {
    padding-top: 60px;
  }

  .brand-icons {
    padding: 45px 0 50px;

    .brand-icons__title {
      font-size: 28px;
      margin-bottom: 50px;
    }

    .brand-icons__row {
      width: 1000px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      text-align: center;

      .brand-icons__item {
        display: block;
        margin: 0 20px;
        text-align: center;

        .brand-icons__img {
          display: block;
          margin: 0 auto;
          width: auto;
          min-width: auto;
        }

        p {
          margin-left: auto;
          margin-right: auto;
          max-width: 150px;
        }

        img {
          height: 75px;
        }
      }
    }
  }
}
</style>
